import React, { lazy } from "react"
import { createRoot } from "react-dom/client"

const Availability = lazy(() => import("../src/pages/availability"))
const CertificationsDatatable = lazy(
  () => import("../src/pages/certifications-datatable")
)
const CertificationsSelfCertify = lazy(
  () => import("../src/pages/certifications-self-certify")
)
const CertificationsSelfServiceConfigForm = lazy(
  () => import("../src/pages/certifications-self-service-config-form")
)
const ConfirmationsDatatable = lazy(
  () => import("../src/pages/confirmations-datatable")
)
const ContactsDatatable = lazy(() => import("../src/pages/contacts-datatable"))
const ContractTags = lazy(() => import("../src/pages/contract-tags"))
const Incidents = lazy(() => import("../src/pages/incidents"))
const JurisdictionsDatatable = lazy(
  () => import("../src/pages/jurisdictions-datatable")
)
const Klasses = lazy(() => import("../src/pages/klasses"))
const LessonPlans = lazy(() => import("../src/pages/lesson-plans"))
const Lessons = lazy(() => import("../src/pages/lessons"))
const LocationCertificationsDatatable = lazy(
  () => import("../src/pages/location-certifications-datatable")
)
const LocationUsers = lazy(() => import("../src/pages/location-users"))
const Organisations = lazy(() => import("../src/pages/organisations"))
const PricingToolPage = lazy(() => import("../src/pages/pricing-tool-page"))
const Procedures = lazy(() => import("../src/pages/procedures"))
const Coupons = lazy(() => import("../src/pages/coupons"))
const Providers = lazy(() => import("../src/pages/providers"))
const QualificationsDatatable = lazy(
  () => import("../src/pages/qualifications-datatable")
)
const UnitGuides = lazy(() => import("../src/pages/unit-guides"))
const Environment = lazy(() => import("../src/components/shared/environment"))
const CompletionWidget = lazy(() => import("../src/widgets/CompletionWidget"))

// Pages render the contents of an entire page using React
const pages: { [name: string]: React.ComponentType } = {
  Availability,
  CertificationsDatatable,
  CertificationsSelfCertify,
  CertificationsSelfServiceConfigForm,
  ConfirmationsDatatable,
  ContactsDatatable,
  ContractTags,
  Incidents,
  JurisdictionsDatatable,
  Klasses,
  LessonPlans,
  Lessons,
  LocationCertificationsDatatable,
  LocationUsers,
  Organisations,
  PricingToolPage,
  Procedures,
  Coupons,
  Providers,
  QualificationsDatatable,
  UnitGuides,
}

// Widgets render a smaller component inside of a larger page
const widgets: { [name: string]: React.ComponentType } = {
  CompletionWidget,
}

document.addEventListener("DOMContentLoaded", () => {
  const metas = document.querySelectorAll<HTMLMetaElement>("meta[name=page]")
  console.log({ metas })

  metas.forEach((meta) => {
    const [pageName, target = "content"] = meta.content.split("#")
    const Page = pages[pageName]
    const el = document.getElementById(target)

    if (!Page) {
      console.warn(`Page not found: ${pageName}`)
      return
    }
    if (!el) {
      console.warn(`Target element missing: ${target}`)
      return
    }

    const root = createRoot(el)
    root.render(
      <Environment>
        <Page />
      </Environment>
    )
  })

  const elements = document.querySelectorAll<HTMLDivElement>("div[data-widget]")
  console.log({ elements })
  elements.forEach((element) => {
    const { widget: widgetName, ...props } = element.dataset
    const Widget = widgetName && widgets[widgetName]

    if (!Widget) {
      console.warn(`Widget not found: ${widgetName}`)
      return
    }

    const root = createRoot(element)
    root.render(
      <Environment>
        <Widget {...props} />
      </Environment>
    )
  })
})
